import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { getImageSrc } from '../../../helpers/getImageSrc'
import TableBodyCell from '../TableBodyCell'
import { getBoxStyles, getTypographyStyles } from './style'

interface DefaultCellProps {
  value: React.ReactNode
  backgroundColor?: string
  withCopyIcon?: boolean
  withTooltip?: boolean
  width?: string
  fontWeight?: string
  borderBottom?: string
}

const DefaultCell = ({
  value,
  backgroundColor,
  withCopyIcon,
  withTooltip,
  width,
  fontWeight,
  borderBottom,
}: DefaultCellProps) => {
  return (
    <TableBodyCell
      backgroundColor={backgroundColor}
      width={width}
      fontWeight={fontWeight}
      borderBottom={borderBottom}
    >
      <Tooltip
        title={value}
        disableHoverListener={!withTooltip}
        placement='top'
      >
        <Box sx={getBoxStyles()}>
          {navigator.clipboard && withCopyIcon && (
            <IconButton
              onClick={(e: any) => {
                e.stopPropagation()
                navigator.clipboard.writeText(String(value).padStart(6, '0'))
              }}
            >
              <img alt={''} src={getImageSrc('copy-table')} />
            </IconButton>
          )}
          <Typography variant='body1' sx={getTypographyStyles(fontWeight)}>
            {value}
          </Typography>
        </Box>
      </Tooltip>
    </TableBodyCell>
  )
}

export default observer(DefaultCell)
